import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ButtonsTranslations } from '~shared/components/buttons/buttons-translations.service';
import { SpinnerService } from '~shared/components/buttons/spinner/spinner.service';
import { ModalOptions } from './modal-options';

@Injectable({ providedIn: 'root' })
export class ModalService {
  public resolve: any;
  public reject: any;
  public isOpen: BehaviorSubject<boolean> = new BehaviorSubject(null);
  public castIsOpen: any = this.isOpen.asObservable();

  public modalOptions: BehaviorSubject<ModalOptions> = new BehaviorSubject(null);
  public castModalOptions: any = this.modalOptions.asObservable();

  constructor(private spinnerService: SpinnerService, private buttonsTranslations: ButtonsTranslations) { }

  public setStatus(status: boolean): void {
    this.isOpen.next(status);
    this.setSpinner(false);
  }

  public openModal(resolve: any, reject: any): any {
    this.setStatus(true);
    this.resolve = resolve;
    this.reject = reject;
  }

  public setModalOptions(
    title: string,
    paragraph: string,
    submitText = this.buttonsTranslations.i18nYes,
    cancelText = this.buttonsTranslations.i18nBack
  ): void {
    const modalOptions = new ModalOptions(title, paragraph, submitText, cancelText);
    this.modalOptions.next(modalOptions);
  }

  public submitButtonClicked(): void {
    this.setSpinner(true);
    this.resolve(true);
  }

  public cancelButtonClicked(): void {
    this.resolve(false);
  }

  public setSpinner(status: boolean): void {
    if (status) {
      this.spinnerService.show('modalSubmit');
    } else {
      this.spinnerService.hide('modalSubmit');
    }
  }
}
